mutation (
  $input: ContactFormInput!
) {
  sendContactForm(
    input: $input
  )
}
